import {gql} from 'apollo-angular';

export const GET_ALL_LOBS = gql`
  query {
    commonLobs {
      id
      name
      type
      label
      sng
    }
  }
`;
